import React from 'react';
import { ImagenEmpleado } from '../../configuracion/apiUrls';
import ModalEmpleado from '../../paginas/empleados/ModalEmpleado';


const PerfilEmpleado = ({ datos }) => {
    const imagen = datos?.imagen ? ImagenEmpleado + datos.imagen : ImagenEmpleado + "empleados.jpeg";

    return (
        <div className='card card-primary card-outline'>
            <div className="card-body box-profile">
                <div className="text-center">
                    <img className="profile-user-img img-fluid img-circle" src={imagen} alt="Imagen de perfil de usuario" crossOrigin="anonymous" />
                </div>
                <h3 className="profile-username text-center">{datos?.nombreCompleto}</h3>
                <p className="text-muted text-center">{datos?.Cargo?.nombre_cargo}</p>
                <hr />
                <div className="card-body">
                    <strong><i className="fas fa-envelope mr-1" /> Correo</strong>
                    <p className="text-muted">
                        {datos?.correo}
                    </p>
                    <strong><i className="fas fa-phone mr-1" /> Telefonos</strong>
                    {
                        datos.EmpleadoTelefonos.map((f, i) => (
                            <p key={i} className="text-muted">
                                {f.telefono}
                            </p>
                        ))
                    }
                    <strong><i className="fas fa-map-marker-alt mr-1" /> Direcciones</strong>
                    {
                        datos.EmpleadoDireccions.map((f, i) => (
                            <p key={i} className="text-muted">
                                {f.direccion}
                            </p>
                        ))
                    }
                    <hr />
                </div>
                <ModalEmpleado datos={datos}></ModalEmpleado>
            </div>
        </div>
    );
}

export default PerfilEmpleado;